import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Tiempo de cache por defecto (5 minutos)
      staleTime: 5 * 60 * 1000,
      // Tiempo de garbage collection (10 minutos)
      gcTime: 10 * 60 * 1000,
      // Reintentar automáticamente en caso de error
      retry: 3,
      // Refetch cuando la ventana vuelve a tener foco
      refetchOnWindowFocus: false,
    },
    mutations: {
      // Reintentar mutaciones en caso de error
      retry: 1,
    },
  },
});